import Phaser, {
    Display
} from 'phaser'

import WorldGraphics from './WorldGraphics'
import WorldToolTips from './ToolTips'
import Navigate from './Navigate';

//*** VARIABLES ***/
let gameScale;
let background;
let midground;
let foreground;
let camera;
let cameraSky;

let isFollow = false;
let cameraLastScrollX = 0;
let cameraLastScrollY = 0;
let speed = 1.75;
let lerp = 0.075;
let skyScroll = 0.4;
let isFirst = true;

let pointerLastX = 0;
let pointerLastY = 0;
let wholeWorld;
let followMe;
let followMeSky;
let widthBounds = 3000;
let heightBounds = 1250;
let utils;
let toolTips;
let startX;
let world;
let hand;
let handAdjust;
let sounds;
let isClick = false;
let clickX;



export default class World extends Phaser.Scene {
    constructor() {
        super('world')
    }

    preload() {
        gameScale = this.registry.values.scaleIt;
    }


    create() {

        utils = this.scene.get('utils');
        world = this;
        sounds = this.scene.get('sounds');

        //game = this;
        // actives = new Array;
        //tooltips = this.scene.get('toolTips');
        //  this.input.setTopOnly(true);
        startX = -50 * gameScale;
        this.registry.set('startX', startX);

        /** Mouse options **/
        this.input.on('pointerdown', this.pointerdown, this);
        this.input.on('pointerup', this.pointerup, this);
        this.input.on('pointerupoutside', this.pointerupoutside, this);
        this.input.on('pointerdownoutside', this.pointerdownoutside, this);
        this.input.on('pointermove', this.pointermove, this);

        this.input.pollRate = 1;
        this.input.setPollOnMove();

        /*Graphics */
        background = this.add.container(startX, -540 * gameScale);
        midground = this.add.container(startX, 100 * gameScale);
        foreground = this.add.container(0, 0);
        hand = utils.addImage(this, {
            id: 'hand'
        })

        hand.visible = false;
        handAdjust = 17;
        if (this.registry.values.isMobile) handAdjust = -1 * handAdjust;


        this.setupCamera();
        //Add a container for all the world so intro can animate it
        wholeWorld = this.add.container(0, 0);
        wholeWorld.add([background, midground, foreground]);

        this.data.set('wholeWorld', wholeWorld);
        //starting properties to animate it to real starting place

        wholeWorld.x = -500 * gameScale;
        wholeWorld.y = +200 * gameScale;
        wholeWorld.scale = 0.7;
        this.scene.add('worldGraphics', WorldGraphics, true, {
            background,
            midground,
            foreground,
            widthBounds,
            heightBounds
        });
        hand.setDepth(300);

        //start the tooltips scene and pass in a container full of textures/images
        //this.scene.add('navigate', Navigate, true);
        this.scene.add('toolTips', WorldToolTips, true, {
            container: midground,
            parent: this.scene.get('navigate')

        });
        //there is another container to find tooltips for.
        toolTips = this.scene.get('toolTips')
        toolTips.startTips(background);

        //when world is setup pause it and start guide
        this.scene.pause('world');

    }

    setupCamera() {
        /** Camera **/
        //using phaser's parallax scrollFactor results in unstable hitareas. Fixed by having 2 cameras following 2 invisble graphics that move at different speeds
        cameraSky = this.cameras.main;

        cameraSky.ignore(foreground);
        cameraSky.ignore(midground);
        cameraSky.ignore(hand);

        camera = this.cameras.add();
        camera.ignore(background);

        let boundsW = (widthBounds * 2) * gameScale;
        let boundsH = heightBounds * gameScale + this.game.canvas.height;

        camera.setBounds(startX, -300 * gameScale, boundsW, boundsH);
        cameraSky.setBounds(startX, -300 * gameScale, boundsW * skyScroll, boundsH);

        this.physics.world.setBounds(startX, -300 * gameScale, widthBounds * gameScale, heightBounds * gameScale - this.game.canvas.height, true, true, true, true);
        //Create small circle to follow
        followMe = this.add.circle(0, 0, 1, 0xFFCC00);
        followMeSky = this.add.circle(0, 0, 1, 0x000066);
        followMe.alpha = followMeSky.alpha = 0;

        //Start Camera Follow
        this.startScroll();

        //parallax foreground images using camera feature
        foreground.scrollFactorX = 1.35;
        //The cursor hand is unaffected by camera scrolling
        hand.scrollFactorX = hand.scrollFactorY = 0;

        //Create invisible graphic for the camera to follow
        this.physics.add.existing(followMe, false);
        this.physics.add.existing(followMeSky, false);
        // @ts-ignore
        followMe.body.setCollideWorldBounds(true);
        // @ts-ignore
        followMeSky.body.setCollideWorldBounds(true);
        // @ts-ignore
        followMeSky.body.setBoundsRectangle(new Phaser.Geom.Rectangle(startX, -300 * gameScale, widthBounds * gameScale * skyScroll, heightBounds * gameScale - this.game.canvas.height));

    }

    resetWorldScroll() {
        followMe.x = followMe.y = followMeSky.x = followMeSky.y = 0;

    }

    setWorldPosition() {
        wholeWorld.x = 0;
        wholeWorld.y = 0;
        wholeWorld.scale = 1;
    }


    //stop following circle around
    stopFollow() {
        isFollow = false;
        isFirst = true;

    }
    startFollow() {
        isFollow = true;
    }
    startScroll() {
        let tempX = followMe.x - this.game.canvas.width / 2 + (-1 * cameraLastScrollX);
        let tempY = followMe.y - this.game.canvas.height / 2 + (-1 * cameraLastScrollY);

        camera.startFollow(followMe, true, lerp, lerp, tempX, tempY);
        cameraSky.startFollow(followMeSky, true, lerp, lerp, tempX, tempY);
    }

    pointermove() {
        // this.updateHand();
        //this.input.hitTestPointer(this.input.activePointer);

        if (isFollow) {

            //instead of ALWAYS updating x keep track of when it starts again
            if (isFirst) {
                pointerLastX = this.input.activePointer.x;
                pointerLastY = this.input.activePointer.y;
            }
            isFirst = false;

            let moveThisX = pointerLastX - this.input.activePointer.x;
            let moveThisY = pointerLastY - this.input.activePointer.y;
            let inc = Math.round(moveThisX * speed);
            followMe.x += moveThisX + inc;
            followMeSky.x += (moveThisX + inc) * skyScroll;

            followMe.y += moveThisY;
            followMeSky.y += moveThisY;

            pointerLastX = this.input.activePointer.x;
            pointerLastY = this.input.activePointer.y;

            cameraLastScrollX = camera.scrollX;
            cameraLastScrollY = camera.scrollY;

        }

    }


    pointerdown() {
        isClick = false;
        this.startFollow();


    }
    pointerup() {
        this.stopFollow();

    }

    getScroll() {
        return ([camera.scrollX, camera.scrollY]);
    }

    pointerupoutside() {

        this.stopFollow();
    }
    pointerdownoutside() {
        this.startFollow();
    }


}